var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e7685ba12515c892bf30c2520bcb4997910642d6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kf_center@zhuanzhuan"]={id:"e7685ba12515c892bf30c2520bcb4997910642d6"};
      